<template>
  <b-modal
    :active.sync="showModal"
    :width="400"
  >
    <form
      class="form"
      @submit.prevent="handleSubmit"
    >
      <div
        class="modal-card"
        style="width: auto;"
      >
        <header class="modal-card-head is-block">
          <span class="icon-static xl large-plus" />
          <h4 class="title is-4">
            Add to a collection
          </h4>
        </header>

        <section
          class="modal-card-body"
          style="padding-top: 0;"
        >
          <p
            class="has-text-centered text large color-bluegrey3 margin-bottom-xl"
          >
            Select to add this item to one or more collections, or create a new collection.
          </p>
          <div
            v-for="(err, i) in formErrors.non_field_errors"
            :key="i"
            class="message is-danger has-text-left"
          >
            <div class="message-body">
              {{ err }}
            </div>
          </div>
          <div class="box has-cells">
            <div class="cell columns has-input">
              <div class="column">
                <input
                  id="id_name"
                  v-model.trim="newCollectionData.name"
                  :class="errorClass('name')"
                  required
                  type="text"
                  name="name"
                  autofocus
                  class="input"
                  placeholder="New collection name"
                >
              </div>

              <a
                class="button is-small is-secondary"
                @click="handleSubmit"
              >Add</a>
            </div>
            <p
              v-for="(err, i) in getErrors('name')"
              :key="i"
              class="help is-danger has-text-left"
            >
              {{ err|capitalize }}
            </p>
            <div>
              <a
                v-for="collection in collections"
                :key="collection.pk"
                class="cell columns"
                @click.prevent="handleSubmit($event, collection.pk)"
              >
                <div class="column">{{ collection.name }}</div>
                <div class="icon-button plus-muted is-narrow" />
              </a>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" />
      </div>
    </form>
  </b-modal>
</template>

<script>
import collectionsClient from '@/api/teamCollections.js'
import { logAddTrackToCollection } from '@/utils/segment.js'

export default {
  name: 'TheCollectionsModal',

  data () {
    return {
      newCollectionData: {
        name: '',
        item_pks: []
      },
      formErrors: {}
    }
  },

  computed: {
    collections: function () {
      return this.$store.getters['collections/collections']
    },

    showModal: {
      get: function () {
        return this.$store.getters['collections/showCollectionsModal']
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.dispatch('collections/showCollectionsModal')
        } else {
          this.$store.dispatch('collections/hideCollectionsModal')
        }
      }
    }
  },

  watch: {
    showModal (isShown) {
      // The modal stays mounted between uses, so don't show errors from last time.
      if (isShown) {
        this.formErrors = {}
      }
    }
  },

  methods: {
    handleSubmit (event, existingCollectionId) {
      if (existingCollectionId === undefined) {
        this.createNewCollection()
      } else {
        this.handleAddToCollection(existingCollectionId)
      }
    },

    handleAddToCollection (collectionId) {
      this.formErrors = {}

      const itemAdding = this.$store.getters['collections/itemAddingToCollection']
      const itemIds = [itemAdding.pk]

      collectionsClient
        .addItems(collectionId, { item_pks: itemIds })
        .then(() => {
          this.$store.dispatch('collections/hideCollectionsModal')
          this.$store.dispatch('collections/setTrackAddingToCollection', null)
          logAddTrackToCollection(itemAdding.artist.name, itemAdding.display_title)
        })
        .catch(error => {
          if (error.response && error.response.status === 400) {
            this.$set(this, 'formErrors', error.response.data)
            return
          }
          const errors = { non_field_errors: ['Something went wrong saving to your collection. Please try again.'] }
          this.$set(this, 'formErrors', errors)
          return Promise.reject(error.response || error)
        })
    },

    createNewCollection () {
      this.formErrors = {}

      const itemAdding = this.$store.getters['collections/itemAddingToCollection']
      this.newCollectionData.item_pks = [itemAdding.pk]

      collectionsClient
        .create(this.newCollectionData)
        .then(() => {
          this.$store.dispatch('collections/fetchCollections')
          this.$store.dispatch('collections/hideCollectionsModal')
          this.$store.dispatch('collections/setTrackAddingToCollection', null)
          this.newCollectionData = {
            name: '',
            item_pks: []
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 400) {
            this.$set(this, 'formErrors', error.response.data)
            return
          }
          const errors = { non_field_errors: ['Something went wrong saving to your collection. Please try again.'] }
          this.$set(this, 'formErrors', errors)
          return Promise.reject(error.response || error)
        })
    },

    getErrors (path) {
      const parts = path.split('.')
      return parts.reduce((p, c) => (p && p[c]) || null, this.formErrors)
    },

    isValid (path) {
      return this.getErrors(path) === null
    },

    errorClass (path) {
      return !this.isValid(path) ? 'is-danger' : ''
    }
  }
}
</script>

<style>
</style>
